var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0L26.3571 5.14286V6.85714H24.6428C24.6428 7.08929 24.5513 7.29018 24.3683 7.45982C24.1852 7.62946 23.9687 7.71429 23.7187 7.71429H3.28122C3.03122 7.71429 2.8147 7.62946 2.63166 7.45982C2.44863 7.29018 2.35711 7.08929 2.35711 6.85714H0.642822V5.14286L13.5 0ZM4.07139 8.57143H7.49997V18.8571H9.21425V8.57143H12.6428V18.8571H14.3571V8.57143H17.7857V18.8571H19.5V8.57143H22.9285V18.8571H23.7187C23.9687 18.8571 24.1852 18.942 24.3683 19.1116C24.5513 19.2812 24.6428 19.4821 24.6428 19.7143V20.5714H2.35711V19.7143C2.35711 19.4821 2.44863 19.2812 2.63166 19.1116C2.8147 18.942 3.03122 18.8571 3.28122 18.8571H4.07139V8.57143ZM25.433 21.4286C25.683 21.4286 25.8995 21.5134 26.0826 21.683C26.2656 21.8527 26.3571 22.0536 26.3571 22.2857V24H0.642822V22.2857C0.642822 22.0536 0.73434 21.8527 0.917376 21.683C1.10041 21.5134 1.31693 21.4286 1.56693 21.4286H25.433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailsIcon);
export default __webpack_public_path__ + "static/media/BankDetailsIcon.f30c04b3ae34da3687847031c76baaf5.svg";
export { ForwardRef as ReactComponent };